import axios from 'axios'

const state = {
  sportList: [],
  bonusPointList: [],
  tourList: [],
  ownTourList: [],
  sportTourList: [],
  tourFields: {},
  tourGroups: [],
  groupGames: [],
  knockoutOdds: [],
  tourListLoaded: true,
  tourFieldsLoaded: true,
  sportListLoaded: true,
  ownTourListLoaded: true,
  sportTourListLoaded: true,
  tourGroupsLoaded: true,
  groupGamesLoaded: true,
  knockoutOddsLoaded: true,
  bonusPointLoaded: true,
}

const getters = {
  sportList: state => state.sportList,
  tourList: state => state.tourList,
  ownTourList: state => state.ownTourList,
  tourFields: state => state.tourFields,
  sportTourList: state => state.sportTourList,
  tourGroups: state => state.tourGroups,
  groupGames: state => state.groupGames,
  knockoutOdds: state => state.knockoutOdds,
  sportListLoaded: state => state.sportListLoaded,
  tourListLoaded: state => state.tourListLoaded,
  tourFieldsLoaded: state => state.tourFieldsLoaded,
  ownTourListLoaded: state => state.ownTourListLoaded,
  sportTourListLoaded: state => state.sportTourListLoaded,
  tourGroupsLoaded: state => state.tourGroupsLoaded,
  groupGamesLoaded: state => state.groupGamesLoaded,
  knockoutOddsLoaded: state => state.knockoutOddsLoaded,
  bonusPointList: state => state.bonusPointList,
  bonusPointLoaded: state => state.bonusPointLoaded,
}

const actions = {
  getSportList({ commit }) {
    commit('SPORTLIST_LOADED', false)
    const token = localStorage.getItem('authToken')
    const header = {'x-auth': token}
    axios.get('/api/sports', { headers: header })
    .then(response => {
      commit('SPORTLIST', response.data)
      commit('SPORTLIST_LOADED', true)
    })
  },
  getBonusPointList ({ commit }, sportId) {
    commit('BONUSPOINT_LOADED', false)
    const token = localStorage.getItem('authToken')
    const header = {'x-auth': token}
    axios.get('/api/bonusPoints/' + sportId, { headers: header })
    .then(response => {
      commit('BONUSPOINTLIST', response.data)
      commit('BONUSPOINT_LOADED', true)
    })
  },
  getTourList({ commit }) {
    commit('TOURLIST_LOADED', false)
    const token = localStorage.getItem('authToken')
    const header = {'x-auth': token}
    axios.get('/api/tournaments', { headers: header })
    .then(response => {
      commit('TOURLIST', response.data)
      commit('TOURLIST_LOADED', true)
    })
  },
  getOwnTourList({ commit }) {
    commit('OWNTOURLIST_LOADED', false)
    const token = localStorage.getItem('authToken')
    const header = {'x-auth': token}
    axios.get('/api/mytournaments', { headers: header })
    .then(response => {
      commit('OWNTOURLIST', response.data)
      commit('OWNTOURLIST_LOADED', true)
    })
  },
  getTourFields({ commit },tourId ) {
    commit('TOURFIELDS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/tournament/' + tourId, { headers: header })
    .then(response => {
      commit('TOURFIELDS', response.data)
      commit('TOURFIELDS_LOADED', true)
    })
  },
  getSportTourList({ commit }, sportId ) {
    commit('SPORTTOURLIST_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/tournamentsBySport/' + sportId, { headers: header })
    .then(response => {
      commit('SPORTTOURLIST', response.data)
      commit('SPORTTOURLIST_LOADED', true)
    })
  },
  getTourGroups( { commit }, tourId ) {
    commit('TOURGROUPS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/tourGroupByTour/' + tourId, { headers: header })
    .then(response => {
      commit('TOURGROUPS', response.data)
      commit('TOURGROUPS_LOADED', true)
    })
  },
  getGroupGames ({ commit }, groupId) {
    commit('GROUPGAMES_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/groupGames/' + groupId, { headers: header })
    .then(response => {
      commit('GROUPGAMES', response.data)
      commit('GROUPGAMES_LOADED', true)
    })
  },
  getGroupGamesByTour ({ commit }, tourId) {
    commit('GROUPGAMES_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/groupGamesByTour/' + tourId, { headers: header })
    .then(response => {
      commit('GROUPGAMES', response.data)
      commit('GROUPGAMES_LOADED', true)
    })
  },
  getKnockoutOdds ({ commit }, tourId ) {
    commit('KNOCKOUTODDS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/knockoutOdd/' + tourId, { headers: header })
    .then(response => {
      commit('KNOCKOUTODDS', response.data)
      commit('KNOCKOUTODDS_LOADED', true)
    })
  }
}

const mutations = {
  SPORTLIST(state, payload) {
    state.sportList = payload
  },
  TOURLIST(state, payload) {
    state.tourList = payload
  },
  TOURLIST_LOADED(state, payload) {
    state.tourListLoaded = payload
  },
  SPORTLIST_LOADED(state, payload) {
    state.sportListLoaded = payload
  },
  OWNTOURLIST(state, payload) {
    state.ownTourList = payload
  },
  OWNTOURLIST_LOADED(state, payload) {
    state.ownTourListLoaded = payload
  },
  TOURFIELDS(state, payload) {
    state.tourFields = payload
  },
  TOURFIELDS_LOADED(state, payload) {
    state.tourFieldsLoaded = payload
  },
  SPORTTOURLIST(state, payload) {
    state.sportTourList = payload
  },
  SPORTTOURLIST_LOADED(state, payload) {
    state.sportTourListLoaded = payload
  },
  TOURGROUPS(state, payload) {
    state.tourGroups = payload
  },
  TOURGROUPS_LOADED(state, payload) {
    state.tourGroupsLoaded = payload
  },
  GROUPGAMES(state, payload) {
    state.groupGames = payload
  },
  GROUPGAMES_LOADED(state, payload) {
    state.groupGamesLoaded = payload
  },
  KNOCKOUTODDS(state, payload) {
    state.knockoutOdds = payload
  },
  KNOCKOUTODDS_LOADED(state, payload) {
    state.knockoutOddsLoaded = payload
  },
  BONUSPOINTLIST(state, payload) {
    state.bonusPointList = payload
  },
  BONUSPOINT_LOADED(state, payload) {
    state.bonusPointLoaded = payload
  },
}

export default {
  state, getters, actions, mutations
}
